import React from 'react';
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

/**
 * Paste in your SVG logo and return it from this component.
 * Make sure you have a height set for your logo.
 * It is recommended to keep the height within 25-35px.
 * Logo comes with a property value called `fill`. `fill` is useful 
 * when you want to change your logo depending on the theme you are on. 
 */
export default function Logo({ fill }) {
  const LogoContainer = styled.div`
    .Logo__Mobile {
      display: none;
    }

    ${mediaqueries.tablet`
      .Logo__Desktop {
        display: none;
      }
      
      .Logo__Mobile{
        display: block;
      }
    `}
  `;

  return (
    <LogoContainer>
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="220pt" height="35pt" viewBox="0 0 2559.000000 408.000000" className="Logo__Desktop"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,408.000000) scale(0.100000,-0.100000)"
      fill={fill} stroke="none">
      <path d="M774 3950 c-57 -12 -136 -53 -185 -97 -112 -101 -139 -287 -65 -448
      l23 -52 -51 10 c-187 34 -368 -85 -383 -251 -6 -61 17 -132 55 -176 50 -56
      195 -75 273 -36 60 31 81 71 77 147 -6 99 -54 144 -136 128 l-37 -8 35 -9 c78
      -20 107 -108 54 -162 -26 -25 -79 -46 -119 -46 -55 0 -135 96 -135 163 0 69
      79 162 158 185 98 29 186 7 346 -87 55 -33 118 -67 139 -77 l37 -18 -32 -10
      c-48 -16 -47 -41 1 -65 22 -12 54 -21 71 -21 19 0 30 -5 30 -14 0 -27 19 -27
      59 -1 31 21 46 25 75 20 34 -7 39 -4 93 53 32 33 85 76 119 96 34 19 115 87
      182 151 l120 115 -19 -50 c-24 -63 -26 -187 -4 -252 45 -132 222 -215 339
      -158 58 27 114 92 129 148 11 42 27 57 27 25 0 -28 55 -117 90 -146 105 -89
      301 -35 372 102 24 46 28 64 28 141 0 52 -6 105 -15 130 -8 23 -15 45 -15 47
      0 3 49 -42 110 -100 60 -57 137 -123 172 -146 35 -23 91 -69 126 -102 59 -57
      65 -61 99 -54 28 5 43 1 74 -20 40 -26 59 -26 59 1 0 10 12 14 40 14 30 0 47
      7 72 30 32 29 32 31 14 45 -11 8 -29 15 -40 15 -13 0 7 16 49 39 39 20 101 56
      139 79 139 83 249 102 341 58 125 -58 162 -147 108 -254 -22 -41 -75 -82 -107
      -82 -42 0 -94 21 -121 48 -23 23 -26 33 -22 70 6 52 29 80 74 88 40 8 26 24
      -20 24 -68 0 -117 -58 -117 -140 0 -56 25 -106 69 -136 30 -20 48 -24 107 -24
      158 0 244 86 231 232 -10 115 -113 223 -234 248 -56 12 -150 9 -186 -5 -18 -7
      -17 -5 2 34 36 70 54 159 48 233 -12 136 -83 239 -208 298 -180 85 -416 13
      -498 -152 -27 -52 -31 -72 -31 -137 0 -66 4 -83 29 -127 84 -146 229 -175 376
      -74 100 69 112 182 27 273 -22 23 -34 27 -78 27 -69 0 -104 -27 -108 -85 -2
      -22 -1 -31 1 -20 24 102 183 64 183 -44 0 -43 -38 -104 -78 -125 -76 -39 -140
      -28 -196 34 -42 46 -60 106 -54 178 15 178 242 243 391 111 145 -127 73 -366
      -143 -472 -62 -31 -69 -32 -190 -32 -112 0 -131 3 -186 26 -89 37 -185 105
      -299 209 -125 115 -201 172 -290 219 l-70 36 -130 0 c-126 0 -132 -1 -199 -33
      -91 -43 -170 -100 -291 -212 -121 -112 -201 -170 -292 -213 -65 -31 -73 -32
      -193 -32 -167 0 -216 19 -316 119 -55 56 -74 83 -87 125 -30 93 -18 171 35
      235 74 90 199 120 300 73 34 -15 66 -39 84 -63 26 -34 29 -45 29 -113 0 -124
      -50 -200 -144 -217 -26 -5 -47 0 -88 20 -87 42 -115 114 -73 184 11 18 32 37
      48 43 37 14 95 -4 110 -33 7 -16 11 -18 11 -7 1 9 -9 31 -22 50 -21 31 -28 34
      -79 37 -53 3 -58 1 -96 -35 -69 -66 -69 -149 -1 -227 103 -117 248 -127 364
      -25 55 48 75 99 75 189 0 58 -6 86 -24 127 -68 145 -248 227 -422 193z m-52
      -100 c-96 -56 -140 -151 -129 -278 17 -181 177 -348 368 -382 58 -11 153 -8
      197 7 15 4 15 3 2 -6 -8 -6 -48 -18 -89 -27 -60 -14 -85 -15 -138 -6 -146 24
      -276 119 -338 245 -94 193 -54 376 100 455 64 34 87 26 27 -8z m2663 6 c197
      -91 202 -381 11 -572 -126 -126 -281 -162 -440 -103 -28 11 -40 17 -26 14 114
      -23 206 -13 305 34 113 53 206 158 239 271 44 146 -11 302 -126 359 -59 29
      -25 27 37 -3z m-1207 -156 c87 -43 111 -62 175 -131 124 -133 171 -248 147
      -357 -10 -45 -22 -65 -69 -113 -40 -41 -68 -60 -98 -69 -75 -19 -156 17 -212
      96 -22 31 -26 47 -26 104 0 60 4 74 30 111 45 64 87 89 149 89 79 0 125 -39
      152 -129 34 -112 -15 -195 -128 -216 -91 -17 -171 105 -107 163 27 26 77 36
      97 20 37 -31 31 -87 -11 -89 -22 0 -22 0 2 -12 20 -10 26 -8 42 12 69 85 -73
      170 -152 92 -40 -40 -42 -115 -4 -160 50 -59 163 -68 228 -18 109 83 89 289
      -35 353 -38 20 -135 17 -184 -5 -57 -26 -112 -83 -120 -126 -6 -36 -24 -49
      -24 -17 0 29 -55 104 -96 132 -30 20 -53 26 -114 28 -73 4 -78 3 -120 -30 -60
      -45 -84 -95 -83 -175 1 -73 35 -142 86 -174 46 -27 145 -27 181 2 37 29 56 70
      56 122 0 59 -31 88 -99 95 -43 4 -53 1 -75 -21 -31 -31 -33 -66 -7 -98 16 -20
      22 -22 42 -12 24 12 24 12 2 12 -12 1 -27 11 -34 22 -15 28 17 73 55 77 35 4
      86 -45 86 -85 0 -40 -32 -87 -70 -103 -27 -11 -39 -11 -84 3 -29 9 -62 27 -74
      39 -63 68 -53 175 24 255 36 39 45 43 88 43 105 0 196 -89 196 -193 0 -59 -42
      -141 -91 -177 -80 -58 -157 -48 -243 30 -55 51 -86 112 -86 171 0 135 157 352
      311 429 147 75 167 75 297 10z"/>
      <path d="M13250 3024 c-69 -8 -157 -20 -196 -28 -39 -8 -106 -17 -150 -21 -43
      -3 -108 -10 -144 -15 -36 -6 -131 -19 -212 -30 -151 -20 -234 -45 -255 -78
      -13 -21 -21 -547 -9 -574 21 -46 121 -75 158 -45 24 19 55 141 63 247 12 155
      33 190 119 190 22 0 66 5 98 12 99 20 91 61 105 -555 7 -293 16 -587 19 -654
      8 -156 4 -164 -97 -187 -43 -10 -83 -25 -96 -38 -48 -45 -17 -140 57 -178 72
      -37 204 -29 470 26 191 40 215 53 214 110 -2 95 -73 158 -193 170 -59 7 -61 8
      -72 43 -27 90 -19 965 11 1172 23 161 103 234 200 184 40 -21 49 -41 60 -137
      23 -184 78 -287 163 -303 43 -8 93 8 107 35 6 11 6 118 0 286 -5 148 -10 282
      -10 297 0 18 -11 39 -29 58 -29 29 -30 29 -143 28 -62 -1 -169 -8 -238 -15z"/>
      <path d="M18885 2931 c-62 -22 -134 -58 -157 -79 -21 -17 -24 -69 -6 -107 17
      -38 65 -62 139 -70 64 -7 67 -8 73 -37 3 -17 3 -35 -2 -42 -4 -6 -7 -292 -7
      -634 l0 -624 -27 -23 c-15 -13 -46 -26 -70 -30 -53 -9 -88 -30 -88 -53 0 -10
      11 -41 25 -69 44 -88 84 -96 337 -67 169 19 245 43 254 81 9 36 -12 99 -42
      122 -15 12 -51 29 -81 38 l-55 17 3 751 c3 573 1 755 -8 771 -7 12 -26 34 -44
      48 -28 24 -38 26 -112 25 -52 0 -101 -7 -132 -18z"/>
      <path d="M6587 2906 c-66 -19 -131 -42 -145 -53 -54 -40 -32 -125 46 -178 29
      -20 49 -25 99 -25 50 0 62 -3 66 -17 8 -30 0 -1296 -8 -1320 -5 -15 -23 -27
      -62 -39 -105 -33 -130 -82 -77 -151 46 -60 68 -66 243 -61 170 5 252 24 318
      74 43 33 48 54 23 113 -23 51 -35 60 -115 77 l-40 9 0 303 c0 302 0 304 22
      322 33 27 261 108 337 120 88 14 139 0 186 -49 55 -57 69 -118 87 -369 14
      -193 15 -224 2 -236 -8 -7 -49 -23 -92 -36 -107 -33 -135 -77 -83 -133 53 -57
      91 -67 258 -67 187 0 320 21 355 56 59 59 -3 167 -106 183 -28 4 -55 11 -58
      15 -4 4 -10 89 -14 189 -13 356 -60 439 -324 571 -139 70 -250 81 -431 45 -85
      -17 -111 -19 -131 -10 l-26 12 9 87 c13 122 9 367 -6 447 -20 107 -78 156
      -180 154 -19 0 -88 -15 -153 -33z"/>
      <path d="M2951 2914 c-64 -27 -252 -240 -409 -462 -153 -215 -397 -632 -472
      -805 -19 -43 -49 -95 -67 -115 l-33 -37 -23 28 c-28 33 -136 248 -166 332 -13
      33 -47 110 -76 170 -58 117 -112 267 -165 455 -42 149 -78 227 -131 285 -68
      74 -105 88 -236 93 -126 5 -237 -11 -458 -63 -247 -59 -285 -78 -285 -146 0
      -27 9 -50 33 -81 51 -67 89 -88 161 -88 88 0 135 -15 148 -48 6 -15 14 -124
      19 -242 8 -239 11 -270 69 -725 53 -429 51 -407 37 -434 -8 -17 -30 -30 -71
      -43 -32 -11 -69 -26 -82 -35 -71 -46 -16 -154 100 -198 61 -24 226 -16 421 19
      170 31 213 45 239 79 19 26 19 28 2 82 -19 62 -89 144 -122 146 -10 0 -47 1
      -81 2 -93 3 -94 5 -104 194 -7 155 -30 471 -49 689 -13 139 -12 225 0 244 9
      13 11 13 20 0 32 -47 206 -360 323 -581 189 -360 246 -444 334 -495 41 -24 51
      -26 138 -22 75 3 100 8 122 24 17 12 58 77 101 160 192 365 495 819 716 1077
      78 91 108 109 134 83 25 -25 20 -100 -16 -236 -41 -155 -92 -650 -92 -891 0
      -133 -11 -152 -98 -169 -80 -16 -142 -37 -164 -57 -45 -41 0 -132 87 -176 93
      -46 560 -47 675 -1 75 30 73 93 -8 181 -44 49 -51 53 -111 62 -72 12 -101 32
      -101 71 0 15 13 81 29 146 37 150 51 258 51 398 0 339 58 646 138 736 l37 42
      127 1 c155 2 164 8 161 93 -2 31 -12 76 -23 100 -17 39 -27 49 -82 73 -81 36
      -160 56 -331 81 -165 24 -317 26 -366 4z"/>
      <path d="M8310 2903 c-45 -24 -67 -63 -81 -149 -10 -57 -10 -77 2 -114 12 -38
      22 -48 74 -76 86 -47 132 -48 172 -6 40 43 63 101 63 165 0 79 -19 118 -75
      157 -58 40 -108 47 -155 23z"/>
      <path d="M22013 2904 c-47 -23 -75 -89 -81 -186 -6 -97 5 -116 90 -159 108
      -54 152 -40 205 68 22 46 25 63 20 113 -7 76 -28 110 -91 149 -58 34 -95 38
      -143 15z"/>
      <path d="M21033 2690 c-12 -5 -29 -23 -38 -41 -15 -28 -16 -55 -10 -208 9
      -229 4 -245 -82 -254 -92 -10 -189 -43 -213 -75 -26 -32 -22 -65 16 -130 36
      -61 75 -76 175 -67 71 6 78 5 88 -13 7 -13 11 -101 11 -239 0 -344 15 -420
      101 -497 66 -60 137 -88 239 -94 79 -4 93 -2 145 22 102 46 176 107 218 177
      44 75 49 127 15 159 -37 34 -79 26 -151 -29 -102 -79 -161 -111 -199 -111 -83
      0 -98 68 -87 401 4 140 10 263 14 275 5 16 28 26 108 49 120 33 213 68 239 92
      11 10 18 30 18 51 0 30 -9 44 -50 84 -57 55 -81 59 -160 28 -71 -28 -126 -29
      -152 -2 -32 32 -36 119 -9 213 12 41 21 85 21 98 0 37 -50 77 -124 100 -73 23
      -99 25 -133 11z"/>
      <path d="M6187 2466 c-8 -8 -17 -33 -21 -55 -3 -22 -10 -42 -15 -45 -5 -3 -39
      8 -75 25 -124 58 -206 50 -369 -33 -95 -49 -191 -148 -273 -280 -97 -157 -144
      -310 -144 -465 1 -94 10 -142 52 -253 28 -73 42 -94 98 -150 37 -36 89 -78
      118 -93 91 -49 265 -70 384 -46 122 24 397 192 443 270 14 25 19 51 18 97 -2
      115 -32 119 -180 21 -143 -94 -187 -115 -291 -141 -166 -40 -342 -22 -396 42
      -34 41 -41 89 -27 182 23 147 78 283 155 383 184 239 353 339 435 257 25 -25
      28 -36 34 -125 10 -153 50 -217 136 -217 56 0 66 28 79 217 17 233 16 301 -6
      343 -32 64 -119 101 -155 66z"/>
      <path d="M4485 2380 c-72 -15 -155 -51 -228 -100 -88 -59 -240 -207 -267 -260
      -25 -50 -26 -111 -2 -133 39 -35 33 -38 412 222 198 135 291 134 324 -4 24
      -99 30 -190 13 -203 -8 -7 -65 -23 -128 -38 -126 -28 -315 -102 -435 -169 -97
      -55 -160 -122 -211 -224 -33 -65 -38 -85 -37 -141 1 -116 37 -181 125 -225
      127 -65 324 -51 576 41 53 18 101 34 108 34 6 0 17 -18 24 -39 18 -62 53 -84
      126 -79 75 5 203 58 250 103 38 35 46 80 24 129 -15 32 -30 38 -109 45 l-65 6
      -1 295 c-1 403 -24 531 -112 631 -79 90 -247 137 -387 109z m255 -768 c27 -22
      37 -90 20 -132 -37 -89 -240 -174 -465 -195 -81 -8 -120 3 -136 39 -10 21 -8
      32 15 69 48 83 199 169 358 206 144 34 179 36 208 13z"/>
      <path d="M10803 2376 c-130 -30 -295 -140 -420 -281 -66 -74 -87 -117 -79
      -164 6 -38 28 -61 59 -61 19 0 106 55 336 214 192 133 286 157 338 87 13 -18
      29 -93 42 -189 7 -59 6 -64 -15 -81 -13 -10 -63 -26 -111 -35 -113 -23 -248
      -73 -395 -148 -94 -47 -127 -70 -172 -118 -158 -172 -169 -390 -23 -482 61
      -38 120 -51 227 -50 111 0 201 19 358 74 62 22 119 37 126 35 7 -3 16 -19 19
      -36 4 -18 18 -43 33 -58 24 -24 30 -25 94 -21 55 4 87 14 165 52 114 56 135
      83 116 154 -16 56 -41 72 -118 72 -58 0 -63 2 -64 23 -1 12 -2 157 -3 322 -3
      407 -24 505 -131 603 -93 86 -242 119 -382 88z m270 -766 c51 -40 44 -120 -16
      -178 -38 -37 -159 -96 -241 -116 -140 -36 -279 -42 -313 -14 -30 25 -8 91 49
      145 78 75 196 127 366 163 113 24 124 24 155 0z"/>
      <path d="M15303 2375 c-87 -19 -181 -66 -265 -134 -89 -71 -199 -184 -221
      -228 -21 -40 -22 -92 -1 -121 31 -45 64 -30 299 137 191 135 254 169 325 178
      45 5 52 3 78 -24 32 -31 46 -80 57 -198 6 -57 4 -73 -8 -83 -8 -7 -64 -24
      -125 -37 -240 -55 -509 -188 -585 -292 -66 -91 -97 -169 -97 -248 0 -175 103
      -257 320 -257 119 0 216 19 375 76 55 20 105 36 112 36 7 0 17 -18 23 -39 27
      -101 140 -107 317 -17 75 37 93 60 93 117 0 72 -22 92 -106 97 -38 3 -73 10
      -77 16 -4 6 -5 108 -1 226 12 407 -25 613 -128 705 -100 91 -236 122 -385 90z
      m264 -760 c12 -9 27 -31 32 -50 21 -79 -27 -142 -154 -201 -89 -41 -165 -61
      -290 -75 -127 -15 -158 -5 -163 53 -3 33 3 44 42 85 81 88 230 157 399 188 96
      18 109 18 134 0z"/>
      <path d="M19984 2376 c-33 -8 -92 -30 -131 -50 -131 -66 -316 -234 -355 -324
      -32 -72 -10 -132 49 -132 18 0 54 23 352 227 136 93 209 122 268 107 29 -7 42
      -17 56 -45 17 -36 48 -224 40 -245 -6 -17 -42 -30 -134 -49 -112 -23 -249 -74
      -392 -148 -92 -47 -129 -72 -170 -117 -147 -158 -168 -356 -50 -460 61 -54
      131 -74 253 -73 113 1 195 18 354 73 65 23 124 39 131 36 7 -2 15 -18 18 -35
      4 -18 18 -43 33 -58 24 -24 30 -25 96 -21 58 5 86 14 166 54 71 36 101 57 110
      77 18 38 8 92 -23 123 -21 20 -34 24 -90 24 -61 0 -65 2 -66 23 0 12 -2 162
      -3 332 -3 329 -9 385 -57 494 -28 67 -111 143 -186 171 -72 27 -190 34 -269
      16z m269 -766 c28 -22 43 -74 32 -110 -29 -92 -212 -182 -423 -210 -114 -15
      -169 -7 -184 25 -45 98 154 240 413 294 120 25 131 25 162 1z"/>
      <path d="M13817 2340 c-117 -40 -146 -56 -153 -85 -10 -41 5 -76 50 -122 36
      -36 50 -43 82 -43 72 0 68 22 71 -398 l3 -379 -48 -7 c-26 -3 -68 -16 -93 -29
      -38 -19 -44 -27 -47 -57 -3 -42 23 -87 71 -124 l34 -26 204 15 c112 9 220 21
      240 26 76 19 114 78 89 138 -11 26 -65 59 -126 76 -79 21 -91 119 -46 375 35
      194 72 299 142 398 45 64 92 112 110 112 19 0 18 -37 0 -120 -22 -98 -26 -229
      -9 -278 12 -35 64 -72 101 -72 27 0 57 28 81 75 28 57 67 196 73 263 5 58 3
      73 -18 112 -47 87 -182 161 -266 145 -62 -11 -128 -54 -187 -121 -31 -35 -61
      -62 -66 -59 -5 4 -9 32 -9 63 0 99 -53 152 -152 152 -24 0 -83 -14 -131 -30z"/>
      <path d="M18503 2355 c-12 -8 -27 -31 -33 -51 -14 -41 -6 -42 -134 11 -167 70
      -248 59 -422 -56 -140 -92 -221 -173 -264 -263 -30 -63 -32 -75 -28 -140 10
      -148 79 -219 293 -299 165 -62 219 -87 301 -139 84 -54 121 -96 102 -113 -21
      -20 -78 -35 -129 -35 -102 0 -274 30 -371 64 -152 55 -226 59 -268 14 -38 -41
      -16 -101 52 -141 65 -37 243 -104 338 -127 111 -27 293 -36 386 -21 91 16 177
      65 250 144 84 91 94 163 34 245 -34 47 -188 143 -289 179 -35 13 -82 34 -105
      47 -22 13 -86 43 -141 66 -133 56 -171 78 -184 107 -10 22 -6 29 41 80 74 77
      158 140 247 183 102 50 145 63 182 55 49 -11 60 -50 52 -187 -6 -109 -5 -118
      20 -171 28 -61 52 -80 100 -75 37 4 65 40 97 126 18 47 21 81 23 221 2 165 2
      166 -26 213 -24 42 -68 78 -94 78 -5 0 -18 -7 -30 -15z"/>
      <path d="M8928 2340 c-94 -24 -154 -53 -163 -79 -10 -32 5 -88 30 -115 12 -13
      42 -30 66 -36 96 -25 87 14 93 -401 4 -306 2 -370 -10 -387 -8 -12 -36 -25
      -66 -33 -73 -17 -88 -28 -88 -64 0 -35 46 -114 81 -139 49 -34 365 -9 435 34
      32 20 54 57 54 90 0 31 -45 74 -99 94 l-51 18 0 293 c0 348 5 386 58 436 57
      54 188 102 277 102 180 0 218 -58 236 -363 6 -96 9 -230 7 -298 -3 -138 -5
      -142 -75 -142 -93 0 -117 -32 -86 -114 31 -84 48 -90 237 -94 246 -6 326 19
      326 100 0 67 -9 78 -88 114 l-75 34 7 203 c8 256 -2 346 -49 444 -46 92 -114
      155 -240 219 l-96 49 -138 3 c-100 3 -159 0 -215 -12 -97 -20 -96 -20 -96 2 0
      10 -7 28 -16 40 -14 20 -23 22 -97 21 -45 0 -117 -9 -159 -19z"/>
      <path d="M16238 2340 c-142 -35 -179 -67 -159 -136 21 -71 39 -85 131 -105 27
      -6 50 -16 50 -22 0 -7 2 -177 5 -378 7 -416 12 -388 -77 -409 -93 -22 -105
      -47 -63 -129 40 -80 61 -91 174 -91 110 0 269 23 312 45 31 16 59 61 59 94 0
      33 -47 78 -101 96 l-51 17 4 322 c4 353 6 367 66 418 18 15 69 41 114 59 66
      26 98 32 153 32 174 0 216 -58 236 -325 11 -149 9 -452 -4 -464 -4 -5 -38 -11
      -74 -15 -98 -10 -112 -42 -62 -141 31 -60 41 -63 264 -63 172 0 204 2 232 18
      40 21 53 45 53 94 0 40 -22 83 -43 83 -7 0 -36 11 -65 25 l-54 25 7 207 c9
      256 -1 339 -50 440 -46 94 -117 158 -242 220 l-95 48 -137 3 c-100 3 -159 0
      -215 -12 -97 -20 -96 -20 -96 2 0 10 -7 28 -16 40 -14 20 -23 22 -97 21 -45 0
      -117 -9 -159 -19z"/>
      <path d="M24038 2336 c-116 -29 -142 -49 -146 -110 -3 -42 0 -50 30 -80 25
      -25 49 -37 91 -46 31 -6 57 -12 57 -13 5 -26 11 -733 6 -751 -5 -21 -17 -29
      -64 -42 -74 -21 -102 -39 -102 -67 0 -35 57 -125 90 -142 57 -29 345 -9 420
      30 64 33 80 103 34 148 -14 14 -48 33 -76 43 l-50 16 5 317 c2 201 8 329 16
      353 16 51 66 91 163 129 92 36 189 43 260 20 106 -35 138 -164 138 -553 0
      -232 -2 -238 -69 -238 -21 0 -52 -5 -70 -11 -27 -10 -31 -15 -31 -47 1 -48 32
      -117 62 -134 17 -10 75 -13 223 -13 172 0 204 2 232 18 40 21 53 45 53 94 0
      53 -15 70 -91 102 l-64 27 3 224 c3 140 0 251 -8 295 -26 158 -115 267 -286
      352 l-96 48 -137 3 c-100 3 -159 0 -215 -12 -83 -17 -96 -15 -96 14 0 10 -7
      26 -16 34 -23 24 -158 20 -266 -8z"/>
      <path d="M8264 2315 c-219 -51 -267 -114 -171 -229 20 -24 34 -31 86 -37 35
      -4 67 -11 72 -16 5 -5 10 -159 12 -348 2 -291 0 -339 -13 -346 -8 -4 -45 -21
      -82 -38 -82 -36 -92 -59 -59 -128 18 -36 31 -49 77 -70 l55 -25 163 11 c166
      11 254 29 276 56 16 19 7 89 -16 138 -16 34 -66 67 -102 67 -10 0 -26 6 -36
      13 -18 13 -18 32 -6 451 13 487 17 449 -59 498 -53 33 -66 34 -197 3z"/>
      <path d="M21951 2310 c-206 -52 -251 -117 -152 -220 32 -34 44 -40 79 -40 23
      0 53 -5 67 -12 l25 -11 0 -342 0 -342 -59 -22 c-32 -12 -70 -30 -85 -42 -53
      -42 -20 -134 64 -177 42 -22 52 -23 165 -17 139 8 246 21 293 36 46 15 55 44
      36 116 -17 68 -48 100 -103 109 -21 3 -44 9 -50 14 -15 9 -15 320 -1 653 5
      124 5 228 0 241 -11 31 -100 86 -136 85 -16 0 -80 -13 -143 -29z"/>
      <path d="M23060 2329 c-32 -5 -102 -32 -169 -65 -154 -77 -222 -141 -289 -272
      -81 -157 -101 -269 -83 -456 13 -127 41 -187 136 -281 124 -124 241 -168 475
      -182 196 -11 334 34 444 143 152 153 243 432 207 640 -31 178 -145 359 -264
      420 -101 52 -311 76 -457 53z m256 -158 c54 -24 111 -76 134 -122 11 -21 29
      -73 41 -116 19 -69 21 -95 16 -223 -8 -197 -39 -302 -111 -372 -52 -50 -226
      -113 -311 -112 -221 1 -360 247 -300 529 16 74 71 200 111 252 25 33 153 142
      191 161 64 34 154 35 229 3z"/>
      <path d="M1341 693 c-64 -32 -75 -120 -21 -168 29 -26 25 -35 -15 -35 -63 0
      -126 47 -139 102 -12 51 -96 74 -155 43 -73 -37 -47 -151 44 -195 51 -25 114
      -28 296 -16 140 10 178 2 159 -34 -16 -29 -13 -31 43 -25 55 6 108 -4 114 -22
      6 -18 -382 -85 -600 -103 -329 -28 -543 52 -671 250 -49 75 -72 100 -92 100
      -44 0 11 -107 92 -179 65 -58 185 -137 232 -151 53 -18 58 -26 21 -39 -77 -27
      -83 -71 -11 -91 72 -20 237 -7 317 25 11 5 -4 -11 -32 -35 -113 -93 -46 -93
      171 -1 295 126 380 145 713 163 268 15 644 0 796 -32 112 -24 269 -78 412
      -144 112 -51 195 -69 195 -43 0 8 -24 34 -52 58 -29 23 -44 39 -33 34 95 -38
      298 -45 350 -11 21 14 24 20 14 37 -6 11 -29 29 -52 39 l-40 18 38 16 c20 9
      41 16 45 16 17 0 167 105 217 153 82 77 121 167 73 167 -14 0 -36 -25 -74 -83
      -85 -130 -156 -187 -289 -232 -110 -37 -236 -48 -395 -35 -130 10 -588 82
      -600 94 -17 17 25 31 94 31 40 -1 74 1 74 3 0 2 -5 12 -10 22 -19 36 19 44
      159 34 246 -16 322 -1 360 75 34 66 27 112 -20 136 -62 33 -140 9 -158 -48
      -18 -55 -62 -89 -121 -95 -27 -2 -50 -2 -50 2 0 4 11 19 25 34 47 50 33 137
      -27 168 -61 32 -181 0 -194 -50 -14 -57 39 -73 101 -30 32 21 42 24 62 15 39
      -18 30 -56 -19 -88 -73 -46 -262 -132 -370 -168 -204 -68 -352 -68 -557 1
      -108 36 -329 137 -381 174 -37 27 -41 66 -7 81 20 9 30 6 62 -15 41 -28 57
      -31 86 -16 27 15 24 42 -11 75 -38 36 -117 45 -169 18z"/>
      </g>
      </svg>
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
          width="35pt" height="35pt" viewBox="0 0 408.000000 408.000000" className="Logo__Mobile"
          preserveAspectRatio="xMidYMid meet">

          <g transform="translate(0.000000,408.000000) scale(0.100000,-0.100000)"
          fill={fill} stroke="none">
          <path d="M774 3950 c-57 -12 -136 -53 -185 -97 -112 -101 -139 -287 -65 -448
          l23 -52 -51 10 c-187 34 -368 -85 -383 -251 -6 -61 17 -132 55 -176 50 -56
          195 -75 273 -36 60 31 81 71 77 147 -6 99 -54 144 -136 128 l-37 -8 35 -9 c78
          -20 107 -108 54 -162 -26 -25 -79 -46 -119 -46 -55 0 -135 96 -135 163 0 69
          79 162 158 185 98 29 186 7 346 -87 55 -33 118 -67 139 -77 l37 -18 -32 -10
          c-48 -16 -47 -41 1 -65 22 -12 54 -21 71 -21 19 0 30 -5 30 -14 0 -27 19 -27
          59 -1 31 21 46 25 75 20 34 -7 39 -4 93 53 32 33 85 76 119 96 34 19 115 87
          182 151 l120 115 -19 -50 c-24 -63 -26 -187 -4 -252 45 -132 222 -215 339
          -158 58 27 114 92 129 148 11 42 27 57 27 25 0 -28 55 -117 90 -146 105 -89
          301 -35 372 102 24 46 28 64 28 141 0 52 -6 105 -15 130 -8 23 -15 45 -15 47
          0 3 49 -42 110 -100 60 -57 137 -123 172 -146 35 -23 91 -69 126 -102 59 -57
          65 -61 99 -54 28 5 43 1 74 -20 40 -26 59 -26 59 1 0 10 12 14 40 14 30 0 47
          7 72 30 32 29 32 31 14 45 -11 8 -29 15 -40 15 -13 0 7 16 49 39 39 20 101 56
          139 79 139 83 249 102 341 58 125 -58 162 -147 108 -254 -22 -41 -75 -82 -107
          -82 -42 0 -94 21 -121 48 -23 23 -26 33 -22 70 6 52 29 80 74 88 40 8 26 24
          -20 24 -68 0 -117 -58 -117 -140 0 -56 25 -106 69 -136 30 -20 48 -24 107 -24
          158 0 244 86 231 232 -10 115 -113 223 -234 248 -56 12 -150 9 -186 -5 -18 -7
          -17 -5 2 34 36 70 54 159 48 233 -12 136 -83 239 -208 298 -180 85 -416 13
          -498 -152 -27 -52 -31 -72 -31 -137 0 -66 4 -83 29 -127 84 -146 229 -175 376
          -74 100 69 112 182 27 273 -22 23 -34 27 -78 27 -69 0 -104 -27 -108 -85 -2
          -22 -1 -31 1 -20 24 102 183 64 183 -44 0 -43 -38 -104 -78 -125 -76 -39 -140
          -28 -196 34 -42 46 -60 106 -54 178 15 178 242 243 391 111 145 -127 73 -366
          -143 -472 -62 -31 -69 -32 -190 -32 -112 0 -131 3 -186 26 -89 37 -185 105
          -299 209 -125 115 -201 172 -290 219 l-70 36 -130 0 c-126 0 -132 -1 -199 -33
          -91 -43 -170 -100 -291 -212 -121 -112 -201 -170 -292 -213 -65 -31 -73 -32
          -193 -32 -167 0 -216 19 -316 119 -55 56 -74 83 -87 125 -30 93 -18 171 35
          235 74 90 199 120 300 73 34 -15 66 -39 84 -63 26 -34 29 -45 29 -113 0 -124
          -50 -200 -144 -217 -26 -5 -47 0 -88 20 -87 42 -115 114 -73 184 11 18 32 37
          48 43 37 14 95 -4 110 -33 7 -16 11 -18 11 -7 1 9 -9 31 -22 50 -21 31 -28 34
          -79 37 -53 3 -58 1 -96 -35 -69 -66 -69 -149 -1 -227 103 -117 248 -127 364
          -25 55 48 75 99 75 189 0 58 -6 86 -24 127 -68 145 -248 227 -422 193z m-52
          -100 c-96 -56 -140 -151 -129 -278 17 -181 177 -348 368 -382 58 -11 153 -8
          197 7 15 4 15 3 2 -6 -8 -6 -48 -18 -89 -27 -60 -14 -85 -15 -138 -6 -146 24
          -276 119 -338 245 -94 193 -54 376 100 455 64 34 87 26 27 -8z m2663 6 c197
          -91 202 -381 11 -572 -126 -126 -281 -162 -440 -103 -28 11 -40 17 -26 14 114
          -23 206 -13 305 34 113 53 206 158 239 271 44 146 -11 302 -126 359 -59 29
          -25 27 37 -3z m-1207 -156 c87 -43 111 -62 175 -131 124 -133 171 -248 147
          -357 -10 -45 -22 -65 -69 -113 -40 -41 -68 -60 -98 -69 -75 -19 -156 17 -212
          96 -22 31 -26 47 -26 104 0 60 4 74 30 111 45 64 87 89 149 89 79 0 125 -39
          152 -129 34 -112 -15 -195 -128 -216 -91 -17 -171 105 -107 163 27 26 77 36
          97 20 37 -31 31 -87 -11 -89 -22 0 -22 0 2 -12 20 -10 26 -8 42 12 69 85 -73
          170 -152 92 -40 -40 -42 -115 -4 -160 50 -59 163 -68 228 -18 109 83 89 289
          -35 353 -38 20 -135 17 -184 -5 -57 -26 -112 -83 -120 -126 -6 -36 -24 -49
          -24 -17 0 29 -55 104 -96 132 -30 20 -53 26 -114 28 -73 4 -78 3 -120 -30 -60
          -45 -84 -95 -83 -175 1 -73 35 -142 86 -174 46 -27 145 -27 181 2 37 29 56 70
          56 122 0 59 -31 88 -99 95 -43 4 -53 1 -75 -21 -31 -31 -33 -66 -7 -98 16 -20
          22 -22 42 -12 24 12 24 12 2 12 -12 1 -27 11 -34 22 -15 28 17 73 55 77 35 4
          86 -45 86 -85 0 -40 -32 -87 -70 -103 -27 -11 -39 -11 -84 3 -29 9 -62 27 -74
          39 -63 68 -53 175 24 255 36 39 45 43 88 43 105 0 196 -89 196 -193 0 -59 -42
          -141 -91 -177 -80 -58 -157 -48 -243 30 -55 51 -86 112 -86 171 0 135 157 352
          311 429 147 75 167 75 297 10z"/>
          <path d="M2951 2914 c-64 -27 -252 -240 -409 -462 -153 -215 -397 -632 -472
          -805 -19 -43 -49 -95 -67 -115 l-33 -37 -23 28 c-28 33 -136 248 -166 332 -13
          33 -47 110 -76 170 -58 117 -112 267 -165 455 -42 149 -78 227 -131 285 -68
          74 -105 88 -236 93 -126 5 -237 -11 -458 -63 -247 -59 -285 -78 -285 -146 0
          -27 9 -50 33 -81 51 -67 89 -88 161 -88 88 0 135 -15 148 -48 6 -15 14 -124
          19 -242 8 -239 11 -270 69 -725 53 -429 51 -407 37 -434 -8 -17 -30 -30 -71
          -43 -32 -11 -69 -26 -82 -35 -71 -46 -16 -154 100 -198 61 -24 226 -16 421 19
          170 31 213 45 239 79 19 26 19 28 2 82 -19 62 -89 144 -122 146 -10 0 -47 1
          -81 2 -93 3 -94 5 -104 194 -7 155 -30 471 -49 689 -13 139 -12 225 0 244 9
          13 11 13 20 0 32 -47 206 -360 323 -581 189 -360 246 -444 334 -495 41 -24 51
          -26 138 -22 75 3 100 8 122 24 17 12 58 77 101 160 192 365 495 819 716 1077
          78 91 108 109 134 83 25 -25 20 -100 -16 -236 -41 -155 -92 -650 -92 -891 0
          -133 -11 -152 -98 -169 -80 -16 -142 -37 -164 -57 -45 -41 0 -132 87 -176 93
          -46 560 -47 675 -1 75 30 73 93 -8 181 -44 49 -51 53 -111 62 -72 12 -101 32
          -101 71 0 15 13 81 29 146 37 150 51 258 51 398 0 339 58 646 138 736 l37 42
          127 1 c155 2 164 8 161 93 -2 31 -12 76 -23 100 -17 39 -27 49 -82 73 -81 36
          -160 56 -331 81 -165 24 -317 26 -366 4z"/>
          <path d="M1341 693 c-64 -32 -75 -120 -21 -168 29 -26 25 -35 -15 -35 -63 0
          -126 47 -139 102 -12 51 -96 74 -155 43 -73 -37 -47 -151 44 -195 51 -25 114
          -28 296 -16 140 10 178 2 159 -34 -16 -29 -13 -31 43 -25 55 6 108 -4 114 -22
          6 -18 -382 -85 -600 -103 -329 -28 -543 52 -671 250 -49 75 -72 100 -92 100
          -44 0 11 -107 92 -179 65 -58 185 -137 232 -151 53 -18 58 -26 21 -39 -77 -27
          -83 -71 -11 -91 72 -20 237 -7 317 25 11 5 -4 -11 -32 -35 -113 -93 -46 -93
          171 -1 295 126 380 145 713 163 268 15 644 0 796 -32 112 -24 269 -78 412
          -144 112 -51 195 -69 195 -43 0 8 -24 34 -52 58 -29 23 -44 39 -33 34 95 -38
          298 -45 350 -11 21 14 24 20 14 37 -6 11 -29 29 -52 39 l-40 18 38 16 c20 9
          41 16 45 16 17 0 167 105 217 153 82 77 121 167 73 167 -14 0 -36 -25 -74 -83
          -85 -130 -156 -187 -289 -232 -110 -37 -236 -48 -395 -35 -130 10 -588 82
          -600 94 -17 17 25 31 94 31 40 -1 74 1 74 3 0 2 -5 12 -10 22 -19 36 19 44
          159 34 246 -16 322 -1 360 75 34 66 27 112 -20 136 -62 33 -140 9 -158 -48
          -18 -55 -62 -89 -121 -95 -27 -2 -50 -2 -50 2 0 4 11 19 25 34 47 50 33 137
          -27 168 -61 32 -181 0 -194 -50 -14 -57 39 -73 101 -30 32 21 42 24 62 15 39
          -18 30 -56 -19 -88 -73 -46 -262 -132 -370 -168 -204 -68 -352 -68 -557 1
          -108 36 -329 137 -381 174 -37 27 -41 66 -7 81 20 9 30 6 62 -15 41 -28 57
          -31 86 -16 27 15 24 42 -11 75 -38 36 -117 45 -169 18z"/>
          </g>
      </svg>
    </LogoContainer>
  );
}